export enum LocalStorageKey {
  token = 'token',
  startToken = 'start_token',
  tempToken = 'temp_token',
  salesModuleToken = 'sales_module_token',
  data = 'data',
  clientVerificationRetries = 'client_verification_retries',
  simulation = 'simulation',
  source = 'source',
  onboardingStarted = 'onboarding_started',
  updateCategoryStepId = 'update_category_step_id',
  salesToken = 'sales_token',
  salesData = 'sales_data',
  phoneEnrollmentFlowContext = 'phone_enrollment_flow_context',
  utmData = 'utm_data'
}
